import Button, { ButtonProps } from 'components/Buttons/Button';
import React from 'react';
import LogInWithImage from 'assets/NHS/LoginButton/LogInWith';
import RegisterWithImage from 'assets/NHS/LoginButton/RegisterWith';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  background-color: #005eb8; // NHS Blue
  box-shadow: 0 4px #003087; // NHS Dark Blue
  border-radius: 4px;
  color: #fff;

  &:hover {
    background-color: #1e569b; // NHS Bright Blue
  }

  &:focus {
    background: #ffeb3b;
    box-shadow: 0 4px 0 #003087;
    color: #003087;
    outline: none;
  }

  .button-logo-text {
    padding-left: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1875rem;
    line-height: 1.47368;
    font-weight: 500;
  }
}
`;

type NHSLoginButtonProps = {
  variant: 'login' | 'register';
} & ButtonProps;

export default ({ variant, ...props }: NHSLoginButtonProps) => (
  <StyledButton {...props} className="">
    {variant === 'login' ? <LogInWithImage width={280} height={27} /> : <RegisterWithImage width={306} height={27} />}{' '}
    <div className="button-logo-text">Continue to NHS login</div>
  </StyledButton>
);
